module.exports = __webpack_public_path__ + "static/logo_makers_mob_light-6dfc403ee3de27d668efb31e21d0f1b5.png";